import { Component, EventEmitter, Output, Input } from '@angular/core';
import { IMenuItem } from 'src/app/classes/interfaces/menu-item';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss'],
})
export class HeaderMobileComponent {

  @Output('logOut') logOut = new EventEmitter<void>();
  @Output('modal') openingModal: EventEmitter<string> = new EventEmitter(false);
  @Input('isLogin') isLogin : boolean;
  @Input('linkPanelMobile') linkPanelMobile : string;
  @Input('userNameMobile') userNameMobile : string;
  @Input('menuItems') menuItems : Array<IMenuItem>;

  activeRoute: string = '';
  menuVisible = false;
  hideSubItem = false;
  dropDownItem: number = -1;

  constructor(private router: Router) {}

  ngOnInit() {
  }
  
  isActive(path: string): boolean {
    return this.router.url.includes(path);
  }

  dropdownStates: boolean[] = []; // برای مدیریت نمایش دراپ‌داون‌ها
  dropdownInDOM: boolean[] = [];  // مدیریت وجود المنت در DOM
  
  showSubItem(index: number) {
    if (this.dropdownStates[index]) {
      this.dropdownStates[index] = false;
      setTimeout(() => {
        this.dropdownInDOM[index] = false;
      }, 300); // زمان انیمیشن باید همین مقدار باشه
    } else {
      this.dropdownInDOM[index] = true;
      setTimeout(() => {
        this.dropdownStates[index] = true;
      }, 10); // یک مقدار تأخیر می‌دیم تا کلاس fade-in اعمال بشه
    }
  }
  

  openModal(type: string) {
    this.openingModal.emit(type);
  }

  logout() {
    this.logOut.emit();
  }

  isVisible = false; 
  isFadingOut = false; 

  openMenu() {
    this.isVisible = true;
    this.isFadingOut = false; 
    document.body.classList.add('overflow-hidden');

  }

  closeMenu() {
    this.isFadingOut = true;
    document.body.classList.remove('overflow-hidden');
  }

  onAnimationEnd() {
    if (this.isFadingOut) {
      this.isFadingOut = false; 
      this.isVisible = false;
    }
  }
}
